import { Box, Typography } from "@mui/material";
import { IncidentPublicSpaceReservationRowExisting } from "../../../../../../data/Incident/types/publicSpace/reservation";
import BoxResponsivePadding from "../../../../../common/boxes/BoxResponsivePadding";
import { dateStringToLongWithDayStringUTC } from "../../../../../../data/common/fieldToString";

type Props = {
  reservation: IncidentPublicSpaceReservationRowExisting 
};
const ReservationCard = ({ reservation  }: Props) => {
  return (
    <BoxResponsivePadding
      display="flex"
      flexWrap="wrap"
      alignItems="center"
      justifyContent="space-between"
      bgcolor="background.default"
      rowGap="16px"
      columnGap="24px"
    >
      <Typography fontWeight="bold">
        {reservation._vdl_nomdusiteareserver_value_Formatted}
      </Typography>
      <Typography>{reservation._vdl_sousplateau_value_Formatted}</Typography>

      <Box>
        <Typography fontWeight="bold">{`${dateStringToLongWithDayStringUTC(
          reservation.vdl_debutdelareservation
        )}`}</Typography>
        <Typography fontWeight="bold">{`au ${dateStringToLongWithDayStringUTC(
          reservation.vdl_findelareservation
        )}`}</Typography>
      </Box>
      <Box display="flex" gap="4px">
        <Typography fontWeight="bold">Contact:</Typography>
        <Typography >{`${reservation.vdl_prenom} ${reservation.vdl_nom}`}</Typography>
      </Box>
    </BoxResponsivePadding>
  );
};

export default ReservationCard;
